import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import './TS_Loader.scss';
import { _className } from '../../utils/tools.js';
export class TS_Loader extends React.Component {
    render() {
        return _jsx("div", { ...this.props, className: _className('ts-loader', this.props.className), children: _jsx("div", { className: "ts-loader__content" }) });
    }
}
//# sourceMappingURL=TS_Loader.js.map